import { useState, useEffect, useMemo, useRef, useCallback} from 'react';
import { useParams } from 'react-router-dom';
import { Edit, Settings, Clock } from 'lucide-react';
import config from '../../devprodConfig.js';
import { createToimenpiteetBulk, getKiinteistot } from '../../api/api.js';
import { syncFromPTSToSections, unsyncFromPTSToSections } from "../utils/syncPTS.js";
import EnergiaBlockLinked from './blocks/EnergiaBlockLinked.jsx';
import html2canvas from "html2canvas";
import { set, get } from "idb-keyval";
import { getUserById,  getEnergiaTablesByKiinteisto, saveEnergiaBlock, createKiinteistoImage, deleteKiinteistoImage, getKiinteistoSasToken, updateReportSectionState } from '../../api/api.js';
import { format } from 'date-fns';
import fi from 'date-fns/locale/fi';
import { confirmAndRun } from '../utils/ConfirmAndRun.jsx';
import React from 'react';
import { Dropdown, DropdownButton, Modal } from 'react-bootstrap';
import '../../App.css';
import { uiSettings } from '../utils/uiSettings.js';
import Can from '../../permissions/Can.jsx';
import { PERMISSIONS } from '../../permissions/permissions.js';
import { usePTS } from '../../context/PTSContext.js';
import { exportAllPTSToExcel } from '../utils/exportAllPTSToExcel';
import { useReportTemplateContext } from './ReportTemplate/ReportTemplateContext.js';
import { blockRegistry, energiaIndexMap, categorizedBlockRegistry } from '../utils/blockUtils.js';
import { fetchPtsImageWithCache, getPtsKey, preloadPtsImages, renderPtsImage, useImageHandler, precompressAllImagesForProperty } from '../utils/ImageHandler.js';
import  {updateTextFields} from '../utils/handleUpdateTextFields'
import { createBlockId, deepCloneWithFreshIds } from '../utils/createBlockID.js';
import { Button } from 'bootstrap';
import SectionVersionsGetter from './SectionVersionsGetter.jsx';
import SectionLastEdited from '../utils/SectionLastEdit.jsx';
import PdfReadyImagesChecker from '../utils/PdfReadyImagesChecker.jsx';
import SectionReadinessButtons from './SectionReadinessButtons.jsx';
import { mittausCacheGet, mittausCacheSet, naytteetCacheAddNotify, naytteetListGet } from '../../utils/mittausCache';
import { getMittausProjekti, createMittausKohde, updateMittausKohde, createNayte, getNaytteetByProjekti } from '../../api/api.js';
import { findLinkedProjectId } from '../../utils/ptsUtils.js';
import { isSentinelTitle, isSentinelSection } from '../../assets/subsectionBlockTemplates';

function computeSectionNumber(sections, report, targetSectionId) {
  let ordered = [...sections];
  if (Array.isArray(report?.section_order) && report.section_order.length > 0) {
    ordered.sort((a, b) => report.section_order.indexOf(a.id) - report.section_order.indexOf(b.id));
  }
  let sectionCounter = 0;
  let tocInserted = false;
  for (let i = 0; i < ordered.length; i++) {
    const s = ordered[i];
    const isCover = (s.name || '').toLowerCase() === 'kansisivu';
    if (!isCover) {
      sectionCounter++;
      if (sectionCounter === 2 && tocInserted) sectionCounter++;
    }
    if (i === 1) tocInserted = true;
    if (s.id === targetSectionId) return isCover ? 0 : sectionCounter;
  }
  return 0;
}

function SubsectionNav({ subsections, activeId, onSetActive, numMap = {} }) {
  return (
    <>
    <style>{`
      .subsection-nav { position: sticky; top: 0; }
      @media (max-width: 767px) { .subsection-nav { position: relative; } }
    `}</style>
    <div className="subsection-nav" style={{
      zIndex: 20,
      backgroundColor: '#f8f9fa', borderBottom: '1px solid #dee2e6',
      padding: '6px 8px', display: 'flex', flexWrap: 'wrap', gap: '4px',
    }}>
      {subsections.map((b) => {
        const isActive = activeId === b.id;
        const isGreen = b.type === 'subsection';
        return (
          <button
            key={b.id}
            className="subsection-nav-btn"
            onClick={() => onSetActive(isActive ? null : b.id)}
            style={{
              padding: '3px 10px',
              borderRadius: 20,
              border: '1px solid',
              borderColor: isActive ? (isGreen ? '#04aa00' : '#495057') : (isGreen ? '#04aa00' : '#adb5bd'),
              backgroundColor: isActive
                ? (isGreen ? '#04aa00' : '#495057')
                : (isGreen ? 'rgba(4,170,0,0.08)' : '#fff'),
              color: isActive ? '#fff' : (isGreen ? '#04aa00' : '#495057'),
              cursor: 'pointer',
              fontWeight: 600,
              whiteSpace: 'nowrap',
              lineHeight: 1.4,
              transition: 'background-color 0.15s, color 0.15s',
            }}
          >
            {numMap[b.id] ? `${numMap[b.id]} ${b.data?.title || '—'}` : (b.data?.title || '—')}
          </button>
        );
      })}
    </div>
    </>
  );
}

const READINESS_HIDDEN_TYPES = new Set([
  'johdanto', 'kansisivu', 'kohteen_perustiedot',
  'lahtotiedot', 'allekirjoitukset', 'kohteentiedot', 'rakenne'
  , 'lvijarjestelmat', 'sahkojarjestelmat', 'rakennetekniikka', 'sahkotekniikka',
  'energiataloudellinen_selvitys', 'rakennetekninen_kuntoarvio','lvi-jarjestelmien_kuntoarvio', 'sahkojarjestelmien_kuntoarvio', 'lvia-tekniikka', 'allekirjoitus'
]);

const READINESS_HIDDEN_REPORT_TYPES = new Set([
  'julkisivujen_kuntotutkimus', 'julkisivujen_kuntotutkimus_v2', 'ikkuna_ovi_raportti', 'ikkunoiden_ja_ulko-ovien_kuntoarvio',
  'TDD',
]);

const SectionActions = React.memo(({ isTemplateView, availablePTSSections, updateSectionFromTemplate, setShowVersions, readiness, onReadinessChange, showReadiness }) => (
  <div className="d-flex flex-wrap align-items-center justify-content-center gap-2 mb-3">
    {showReadiness && (
      <SectionReadinessButtons readiness={readiness} onChange={onReadinessChange} />
    )}
  </div>
));

// Add this small wrapper component above renderBlocks or at the top of the file
const SubsectionTitleInput = React.memo(({ value, onCommit, className }) => {
  const [localValue, setLocalValue] = useState(value);

  // Sync if parent value changes (e.g. version restore)
  useEffect(() => { setLocalValue(value); }, [value]);

  return (
    <input
      className={className}
      value={localValue}
      onChange={(e) => setLocalValue(e.target.value)}
      onBlur={() => onCommit(localValue)}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === 'Escape') {
          onCommit(localValue);
          e.target.blur();
        }
      }}
      autoFocus
    />
  );
});

const PATH_SEP = ' › ';
const textLabelFor = (block, blocks, index) => {
  const hint = (block?.data?.hint || '')
    .replace(/VL:\([^)]*\)/g, '')
    .replace(/\{[^}]*\}/g, '')
    .replace(/\s+/g, ' ')
    .trim();
  if (hint) return hint;
  const textIndex = blocks.slice(0, index).filter(b => b?.type === 'LexicalTextarea').length;
  return `Tekstikenttä ${textIndex + 1}`;
};


  export default function ReportSectionRenderer() {

  const {
    report,
    sections,
    updateSection,
    updateOtherSectionContent,
    editMode,
    setEditMode,

    rakennusData: kiinteisto,
    mergedRakennusData,
    setMergedKiinteisto: setMergedRakennusData, // rename if you use different naming

    fetchReportData,
    riskidata,

    // ✅ Block editing additions
    content,

    activeSectionId,
    activeSection,
    activeSubsectionId,
    setActiveSubsectionId,

    handleBlockChange,
    handleBlockBlur,
    renameSection,
    handleAddBlock,
    handleDeleteBlock,
    moveBlock,
    updateSectionFromTemplate,
    lockedSections,
    popup,
    showPopup,
    groupedToimenpiteet = {},
    versionKey,
    extractMeaningfulReportData
  } = useReportTemplateContext();

  const isLocked = useMemo(
  () => lockedSections[activeSectionId] === true,
  [lockedSections, activeSectionId]
  );

  const linkedProjectId = useMemo(() => findLinkedProjectId(sections), [sections]);

  useEffect(() => {
    console.log('Locked sections', lockedSections)
    console.log('Islocked bool', isLocked)
  }, [isLocked])
  

    const {
      availablePTSSections,
      years, currentYear,
      tekniikkaData, lviData, sahkoData, tutkimusData,
      tekniikkaYhteensa, lviYhteensa, sahkoYhteensa, tutkimusYhteensa,
    } = usePTS();

    const { 
      id: kiinteistoId,                
      reportId,                  
    } = useParams();

    useEffect(() => {
    if (activeSubsectionId) window.scrollTo({ top: 0, behavior: 'instant' });
  }, [activeSubsectionId]);

  // Warm the PDF image cache for all property images in the background
    useEffect(() => {
      if (kiinteistoId) precompressAllImagesForProperty(kiinteistoId).catch(console.error);
    }, [kiinteistoId]);

    const [unsavedChanges, setUnsavedChanges] = useState(false);
    const saveTimeoutRef = useRef(null);
    const [editingName, setEditingName] = useState(false);
    const [editingSubsections, setEditingSubsections] = useState(new Set());
    const [openSettings, setOpenSettings] = useState(null);
    const [optimisticSettings, setOptimisticSettings] = useState({});

    const getPageBreak = (block) =>
      block.id in optimisticSettings
        ? !!optimisticSettings[block.id]?.pageBreakBefore
        : !!block.data?.pageBreakBefore;

    const togglePageBreak = (block, blockPath) => {
      const newVal = !getPageBreak(block);
      setOptimisticSettings(p => ({ ...p, [block.id]: { ...p[block.id], pageBreakBefore: newVal } }));
      handleBlockChange(blockPath, { ...block.data, pageBreakBefore: newVal });
    };

    const getLandscape = (block) =>
      block.id in optimisticSettings
        ? !!optimisticSettings[block.id]?.landscapePage
        : !!block.data?.landscapePage;

    const toggleLandscape = (block, blockPath) => {
      const newVal = !getLandscape(block);
      setOptimisticSettings(p => ({ ...p, [block.id]: { ...p[block.id], landscapePage: newVal } }));
      handleBlockChange(blockPath, { ...block.data, landscapePage: newVal });
    };

    const ALL_VIEW_FIELD = {
      PoranayteBlock: 'allNaytteet',
      OhuthieBlock: 'allKohteet',
      VetolujuusBlock: 'allKohteet',
      KloridipitoisuusBlock: 'allKohteet',
    };

    const getAllView = (block) => {
      const field = ALL_VIEW_FIELD[block.type];
      if (!field) return undefined;
      const opt = optimisticSettings[block.id]?.[field];
      if (opt !== undefined) return !!opt;
      if (block.data?.[field] !== undefined) return !!block.data[field];
      return window.innerWidth >= 768;
    };

    const setAllView = (block, blockPath, newVal) => {
      const field = ALL_VIEW_FIELD[block.type];
      if (!field) return;
      setOptimisticSettings(p => ({ ...p, [block.id]: { ...p[block.id], [field]: newVal } }));
      handleBlockChange(blockPath, { ...block.data, [field]: newVal });
    };

    const blockRefs = useRef({});
    const [ptsImageUrls, setPtsImageUrls] = useState({});
    const SYSTEM_USER_ID = 15;
    const isTemplateView = kiinteistoId === undefined;
    const [updatedByUser, setUpdatedByUser] = useState(null);
    const [energiaTables, setEnergiaTables] = useState(null);

    // Global table numbering: compute blockId → starting Taulukko number by scanning all sections
    const tableNumberMap = useMemo(() => {
      const map = new Map();
      if (!Array.isArray(sections)) return map;
      let counter = 1;
      function countBlocks(blocks) {
        for (const block of (blocks ?? [])) {
          if (block.type === 'VetolujuusBlock' || block.type === 'PoranayteBlock' || block.type === 'OhuthieBlock' || block.type === 'KloridipitoisuusBlock'
            || block.type === 'VetolujuusBlockV2' || block.type === 'PoranayteBlockV2' || block.type === 'OhuthieBlockV2' || block.type === 'KloridipitoisuusBlockV2' || block.type === 'RappausnayteBlockV2') {
            // v2 counterparts each show exactly one table (unlike v1's
            // Peitepaksuus/testi-type blocks, which can loop several kohteet
            // worth in one block instance) — same +1 as their v1 equivalents.
            if (block.id) map.set(block.id, counter);
            counter += 1;
          } else if (block.type === 'LexicalTextarea') {
            const tblCount = (block.data?.html || '').match(/<table/gi)?.length || 0;
            if (tblCount > 0) {
              if (block.id) map.set(block.id, counter);
              counter += tblCount;
            }
          } else if (block.type === 'PeitepaksuusBlock') {
            if (block.id) map.set(block.id, counter);
            const projekt = block.data?.mittausProjektiId ? mittausCacheGet(block.data.mittausProjektiId) : null;
            if (projekt) {
              const filteredKohteet = (projekt.kohteet ?? []).filter(k =>
                (k.data?.cover_measurements?.length || 0) > 0 || (k.data?.carbonation_measurements?.length || 0) > 0
              );
              const slots = filteredKohteet.reduce((sum, k) => sum + 1 + ((k.data?.cover_measurements?.length || 0) > 0 ? 1 : 0), 0);
              counter += Math.max(1, slots);
            } else {
              counter += 1;
            }
          } else if (block.type === 'PeitepaksuusBlockV2') {
            // v2's Peitepaksuus block instance is scoped to a single
            // rakenneosa (not v1's whole-mittausProjekti loop), and always
            // emits exactly 2 tables for it — cover measurements + chart.
            if (block.id) map.set(block.id, counter);
            counter += 2;
          }
          if ((block.type === 'subsection' || block.type === 'subsection2') && Array.isArray(block.data?.blocks)) {
            countBlocks(block.data.blocks);
          }
        }
      }
      let orderedSections = [...sections];
      if (Array.isArray(report?.section_order) && report.section_order.length > 0) {
        orderedSections.sort((a, b) => report.section_order.indexOf(a.id) - report.section_order.indexOf(b.id));
      }
      for (const section of orderedSections) {
        try {
          const parsed = section.content ? JSON.parse(section.content) : {};
          countBlocks(parsed.blocks ?? []);
        } catch { /* ignore */ }
      }
      return map;
    }, [sections, report?.section_order, kiinteistoId]);

    const currentSectionNum = useMemo(() => {
      if (!activeSection || !sections?.length || !report) return 0;
      return computeSectionNumber(sections, report, activeSection.id);
    }, [sections, report, activeSection?.id]);

    const subsectionNumMap = useMemo(() => {
      if (!currentSectionNum) return {};
      const map = {};
      let counter = 0;
      function scan(blocks) {
        for (const b of blocks ?? []) {
          if (b.type === 'subsection') {
            counter++;
            if (b.id) map[b.id] = `${currentSectionNum}.${counter}`;
            scan(b.data?.blocks);
          } else if (b.type === 'subsection2') {
            scan(b.data?.blocks);
          }
        }
      }
      scan(content?.blocks);
      return map;
    }, [content?.blocks, currentSectionNum]);

    const [showVersions, setShowVersions] = useState(false);
    const [showDebugJson, setShowDebugJson] = useState(false);
    const [showTemplateModal, setShowTemplateModal] = useState(false);
    const [pasteBlockJson, setPasteBlockJson] = useState('');
    const [pasteBlockError, setPasteBlockError] = useState('');

    const [copiedBlock, setCopiedBlock] = useState(() => {
      try { const s = localStorage.getItem('ktp_copied_block'); return s ? JSON.parse(s) : null; } catch { return null; }
    });

    const handleCopyBlock = useCallback((block) => {
      const payload = { type: block.type, data: block.data };
      try { localStorage.setItem('ktp_copied_block', JSON.stringify(payload)); } catch {}
      setCopiedBlock(payload);
    }, []);

    const handlePasteClipboardBlock = useCallback((path = []) => {
      if (!copiedBlock) return;
      const newBlock = deepCloneWithFreshIds(copiedBlock);
      const newContent = structuredClone(content);
      let blocks = newContent.blocks;
      for (let i = 0; i < path.length; i++) blocks = blocks[path[i]].data.blocks;
      blocks.push(newBlock);
      handleBlockBlur(newContent);
    }, [copiedBlock, content, handleBlockBlur]);

    const handlePasteBlock = useCallback(() => {
      setPasteBlockError('');
      let parsed;
      try { parsed = JSON.parse(pasteBlockJson); } catch {
        setPasteBlockError('Virheellinen JSON'); return;
      }
      const incoming = Array.isArray(parsed.blocks) ? parsed.blocks : [parsed];
      if (!incoming.length || !incoming[0]?.type) { setPasteBlockError('Ei kelvollinen lohko'); return; }
      const newBlocks = incoming.map(b => deepCloneWithFreshIds(b));
      const updated = { ...content, blocks: [...(content?.blocks ?? []), ...newBlocks] };
      if (activeSection) updateSection({ ...activeSection, content: JSON.stringify(updated) });
      handleBlockBlur(updated);
      setPasteBlockJson('');
    }, [pasteBlockJson, content, handleBlockBlur, activeSection, updateSection]);

    const readiness = useMemo(
      () => content?.readiness ?? { rakenne: 'not_ready', lvi: 'not_ready', sahko: 'not_ready' },
      [content?.readiness]
    );

    const handleReadinessChange = useCallback((discipline, newValue) => {
      const updated = { ...content, readiness: { ...readiness, [discipline]: newValue } };
      handleBlockBlur(updated);
    }, [content, readiness, handleBlockBlur]);

    const showReadiness = !isTemplateView && !READINESS_HIDDEN_TYPES.has(activeSection?.type) && !READINESS_HIDDEN_REPORT_TYPES.has(report?.type);


    const [sectionNameInput, setSectionNameInput] = useState(activeSection?.name || "");


  useEffect(() => {
    document.body.classList.toggle("pts-edit-mode", editMode);
  }, [editMode]);


  useEffect(() => {
    if (!kiinteisto?.id_kiinteisto) return;

    getEnergiaTablesByKiinteisto(kiinteisto.id_kiinteisto)
      .then(res => {
        if (res.data?.length > 0) {
          setEnergiaTables(res.data[0]);
        }
      })
      .catch(err => {
        console.error("Failed to load energia tables:", err);
      });
 }, [kiinteisto?.id_kiinteisto]);

  // Saves a single energia block from report to energia_tables just like the Energia tab
  const handleEnergiaSave = async (blockIndex, updatedBlock) => {
    if (!energiaTables) return;

    try {
      await saveEnergiaBlock(energiaTables, blockIndex, updatedBlock);

      // update local state immediately
      setEnergiaTables(prev => {
        const updated = structuredClone(prev);
        updated.data.blocks[blockIndex] = {
          ...updated.data.blocks[blockIndex],
          ...updatedBlock,
          title: updated.data.blocks[blockIndex].title
        };
        return updated;
      });

      console.log("Energia block saved!");
    } catch (err) {
      console.error("Energia save failed:", err);
    }
  };

// Recursively preload all PTS images in blocks
useEffect(() => {
  const preloadPtsImages = async (blocks = []) => {
    if (!Array.isArray(blocks)) return;

    for (const block of blocks) {
      if (block?.data?.imageRef) {
        await fetchPtsImageWithCache(
          block.data.imageRef,
          kiinteisto?.id_kiinteisto,
          ptsImageUrls,
          setPtsImageUrls
        );
      }

      if (block.type === "subsection" && Array.isArray(block.data?.blocks)) {
        await preloadPtsImages(block.data.blocks);
      }
    }
  };

  if (Array.isArray(content.blocks) && content.blocks.length > 0 && kiinteisto?.id_kiinteisto) {
    preloadPtsImages(content.blocks);
  }
}, [content, kiinteisto?.id_kiinteisto]);


const handleBlockChangeMemo = useCallback(
  (blockPath, newData, expectedBlockId) => {
    handleBlockChange(blockPath, newData, expectedBlockId);
  },
  [handleBlockChange]
);

const syncInFlight = useRef(new Set());
const syncPoranayteRow = useCallback(async ({ nayteId, rakenneosa, nayteTunnus, testi, updateOnly = false }) => {
  function findByType(type, blocks) {
    const results = [];
    for (const b of blocks ?? []) {
      if (b.type === type) results.push(b);
      if (b.data?.blocks) results.push(...findByType(type, b.data.blocks));
    }
    return results;
  }
  let topBlocks = [];
  try { topBlocks = (activeSection?.content ? JSON.parse(activeSection.content) : {}).blocks ?? []; } catch {}

  for (const pb of findByType('PeitepaksuusBlock', topBlocks)) {
    const projId = pb.data?.mittausProjektiId;
    if (!projId) continue;
    let proj = mittausCacheGet(projId);
    if (!proj) { try { proj = (await getMittausProjekti(projId)).data; mittausCacheSet(proj.id, proj); } catch { continue; } }
    const existingKohde = (proj.kohteet ?? []).find(k => k.nayte_id === nayteId);
    if (existingKohde) {
      if (nayteTunnus && existingKohde.data?.nayteTunnus !== nayteTunnus) {
        const newData = { ...existingKohde.data, nayteTunnus };
        try { await updateMittausKohde(existingKohde.id, { data: newData }); mittausCacheSet(proj.id, { ...proj, kohteet: proj.kohteet.map(k => k.id === existingKohde.id ? { ...k, data: newData } : k) }); } catch {}
      }
      continue;
    }
    if (updateOnly) continue;
    // One tab per rakenneosa — skip if a kohde with this name already exists
    if ((proj.kohteet ?? []).some(k => k.nimi === (rakenneosa || nayteTunnus))) continue;
    const pFlightKey = `${projId}:${nayteId}`;
    if (syncInFlight.current.has(pFlightKey)) continue;
    syncInFlight.current.add(pFlightKey);
    try {
      const res = await createMittausKohde(proj.id, rakenneosa || nayteTunnus, proj.kohteet?.length ?? 0, nayteId);
      const initData = { cover_measurements: [], carbonation_measurements: { alapinta: [], ylapinta: [] }, nayteTunnus };
      await updateMittausKohde(res.data.id, { data: initData });
      mittausCacheSet(proj.id, { ...proj, kohteet: [...(proj.kohteet ?? []), { ...res.data, nayte_id: nayteId, data: initData }] });
    } catch { /* ignore */ } finally { syncInFlight.current.delete(pFlightKey); }
  }

  if (!testi) {
    // Sync nayteTunnus into first row of veto/ohuthie/kloridi kohteet
    if (nayteTunnus) {
      for (const blockType of ['VetolujuusBlock', 'OhuthieBlock', 'KloridipitoisuusBlock']) {
        for (const block of findByType(blockType, topBlocks)) {
          const projId = block.data?.mittausProjektiId;
          if (!projId) continue;
          let proj = mittausCacheGet(projId);
          if (!proj) { try { proj = (await getMittausProjekti(projId)).data; mittausCacheSet(proj.id, proj); } catch { continue; } }
          const kohde = (proj.kohteet ?? []).find(k => k.nayte_id === nayteId);
          if (!kohde) continue;
          const rows = Array.isArray(kohde.data) ? kohde.data : [];
          if (!rows.length || rows[0]?.tunnus === nayteTunnus) continue;
          const newRows = rows.map((r, i) => i === 0 ? { ...r, tunnus: nayteTunnus } : r);
          try {
            await updateMittausKohde(kohde.id, { data: newRows });
            mittausCacheSet(proj.id, { ...proj, kohteet: proj.kohteet.map(k => k.id === kohde.id ? { ...k, data: newRows } : k) });
          } catch {}
        }
      }
    }
    return;
  }
  const testiList = testi.split(',').map(s => s.trim().toLowerCase()).filter(Boolean);

  if (testiList.includes('kloridi')) {
    for (const kb of findByType('KloridipitoisuusBlock', topBlocks)) {
      const projId = kb.data?.mittausProjektiId;
      if (!projId) continue;
      let proj = mittausCacheGet(projId);
      if (!proj) { try { proj = (await getMittausProjekti(projId)).data; mittausCacheSet(proj.id, proj); } catch { continue; } }
      if ((proj.kohteet ?? []).some(k => k.nayte_id === nayteId)) continue;
      const kFlightKey = `${projId}:${nayteId}`;
      if (syncInFlight.current.has(kFlightKey)) continue;
      syncInFlight.current.add(kFlightKey);
      try {
        const res = await createMittausKohde(proj.id, rakenneosa || nayteTunnus, proj.kohteet?.length ?? 0, nayteId);
        const initRow = { id: crypto.randomUUID(), tunnus: nayteTunnus || '', kloridipitoisuus: '', nayteId };
        await updateMittausKohde(res.data.id, { data: [initRow] });
        mittausCacheSet(proj.id, { ...proj, kohteet: [...(proj.kohteet ?? []), { ...res.data, nayte_id: nayteId, data: [initRow] }] });
      } catch { /* ignore */ } finally { syncInFlight.current.delete(kFlightKey); }
    }
  }
  if (testiList.includes('veto')) {
    for (const vb of findByType('VetolujuusBlock', topBlocks)) {
      const projId = vb.data?.mittausProjektiId;
      if (!projId) continue;
      let proj = mittausCacheGet(projId);
      if (!proj) { try { proj = (await getMittausProjekti(projId)).data; mittausCacheSet(proj.id, proj); } catch { continue; } }
      if ((proj.kohteet ?? []).some(k => k.nayte_id === nayteId)) continue;
      const vFlightKey = `${projId}:${nayteId}`;
      if (syncInFlight.current.has(vFlightKey)) continue;
      syncInFlight.current.add(vFlightKey);
      try {
        const res = await createMittausKohde(proj.id, rakenneosa || nayteTunnus, proj.kohteet?.length ?? 0, nayteId);
        const initRow = { id: crypto.randomUUID(), tunnus: nayteTunnus || '', diameter: 55, vetolujuus: '', murtosyvyysFrom: '', murtosyvyysTo: '', murtosyvyysType: 'up', murtotapa: 'Osittain runkoainesta leikaten', lisahuomiot: '', nayteId };
        await updateMittausKohde(res.data.id, { data: [initRow] });
        mittausCacheSet(proj.id, { ...proj, kohteet: [...(proj.kohteet ?? []), { ...res.data, nayte_id: nayteId, data: [initRow] }] });
      } catch { /* ignore */ } finally { syncInFlight.current.delete(vFlightKey); }
    }
  }
  if (testiList.includes('ohuthie')) {
    for (const ob of findByType('OhuthieBlock', topBlocks)) {
      const projId = ob.data?.mittausProjektiId;
      if (!projId) continue;
      let proj = mittausCacheGet(projId);
      if (!proj) { try { proj = (await getMittausProjekti(projId)).data; mittausCacheSet(proj.id, proj); } catch { continue; } }
      if ((proj.kohteet ?? []).some(k => k.nayte_id === nayteId)) continue;
      const oFlightKey = `${projId}:${nayteId}`;
      if (syncInFlight.current.has(oFlightKey)) continue;
      syncInFlight.current.add(oFlightKey);
      try {
        const res = await createMittausKohde(proj.id, rakenneosa || nayteTunnus, proj.kohteet?.length ?? 0, nayteId);
        const initRow = { id: crypto.randomUUID(), tunnus: nayteTunnus || '', naytteenottokohta: '', laatuluokka: '', kuntoluokka: '', pakkasrapautuneisuus: '', nayteId };
        await updateMittausKohde(res.data.id, { data: [initRow] });
        mittausCacheSet(proj.id, { ...proj, kohteet: [...(proj.kohteet ?? []), { ...res.data, nayte_id: nayteId, data: [initRow] }] });
      } catch { /* ignore */ } finally { syncInFlight.current.delete(oFlightKey); }
    }
  }
}, [activeSection]);


const createNayteForSection = useCallback(async (rakenneosa, tunnus = '', testi = '') => {
  function findByType(type, blocks) {
    const results = [];
    for (const b of blocks ?? []) {
      if (b.type === type) results.push(b);
      if (b.data?.blocks) results.push(...findByType(type, b.data.blocks));
    }
    return results;
  }
  let topBlocks = [];
  try { topBlocks = (activeSection?.content ? JSON.parse(activeSection.content) : {}).blocks ?? []; } catch {}
  const pb = findByType('PoranayteBlock', topBlocks)[0];
  if (!pb?.data?.mittausProjektiId) return null;
  const projId = pb.data.mittausProjektiId;
  if (tunnus) {
    let existing = naytteetListGet(projId);
    if (!existing) {
      try { const r = await getNaytteetByProjekti(projId); existing = r.data ?? []; } catch { existing = []; }
    }
    if (existing.some(n => n.nayte_tunnus === tunnus)) {
      throw Object.assign(new Error('Näytetunnus on jo olemassa. Voit lisätä testejä näytteelle poranäyte taulukosta.'), { code: 'DUPLICATE_TUNNUS' });
    }
  }
  const res = await createNayte(projId, { rakenneosa, nayte_tunnus: tunnus, naytteen_pinta: '55', sort_order: 9999, ...(testi ? { testi } : {}) });
  naytteetCacheAddNotify(projId, res.data);
  return res.data;
}, [activeSection]);

const toggleEditingSubsection = (blockId) => {
  setEditingSubsections(prev => {
    const newSet = new Set(prev);
    if (newSet.has(blockId)) newSet.delete(blockId);
    else newSet.add(blockId);
    return newSet;
  });
};
    
  const handleCaptureBlockImage = async (blockPath, block) => {
    // const key = blockPath.join("-");
    const element = blockRefs.current[block.id];
    const propertyId = kiinteisto?.id_kiinteisto;
    const showPart = block.data?.showPart || "all";

    if (!element) return alert("Lohkoa ei löytynyt!");
    if (!propertyId) return alert("Kiinteistön ID puuttuu, ei voida tallentaa kuvaa.");

    try {
      let blob;

      // --- Capture MapBlock via Leaflet ---
      if (block.type === "MapBlock2") {
        const mapContainer = element.querySelector(".leaflet-container");
        if (!mapContainer) throw new Error("Leaflet-karttaa ei löytynyt elementistä");
        const mapInstance = mapContainer._leaflet_map;
        if (!mapInstance) throw new Error("Leaflet-kartta-instanssia ei löytynyt");

        const leafletImage = await import("leaflet-image");
        blob = await new Promise((resolve, reject) => {
          leafletImage.default(mapInstance, (err, canvas) => {
            if (err || !canvas) return reject(err || new Error("Leaflet-image epäonnistui"));
            canvas.toBlob(b => (b ? resolve(b) : reject(new Error("Blob conversion failed"))), "image/png");
          });
        });
      } else {
        // --- Capture normal HTML block ---
        const canvas = await html2canvas(element, { scale: 2, useCORS: true, backgroundColor: "#fff", logging: false, removeContainer: true });
        const needsCrop = ["PtsBlockTutkimukset","PtsBlockSahko","PtsBlockRakennetekniikka","PtsBlockLVI"].includes(block.type);
        let croppedCanvas = canvas;

        if (needsCrop) {
          const cropHeight = 65;
          const newCanvas = document.createElement("canvas");
          newCanvas.width = canvas.width;
          newCanvas.height = canvas.height - cropHeight;
          const ctx = newCanvas.getContext("2d");
          ctx.drawImage(canvas, 0, cropHeight, canvas.width, canvas.height - cropHeight, 0, 0, canvas.width, canvas.height - cropHeight);
          croppedCanvas = newCanvas;
          
        }
            if (block.type.startsWith("EnergiaBlock")) {
              const cropTop = 90; // px — trims title + Muokkaa
              const newCanvas = document.createElement("canvas");
              newCanvas.width = croppedCanvas.width;
              newCanvas.height = croppedCanvas.height - cropTop;
              const ctx = newCanvas.getContext("2d");
              ctx.drawImage(
                croppedCanvas,
                0, cropTop,
                croppedCanvas.width, croppedCanvas.height - cropTop,
                0, 0,
                croppedCanvas.width, croppedCanvas.height - cropTop
              );
              croppedCanvas = newCanvas;
            }
        blob = await new Promise((resolve, reject) => croppedCanvas.toBlob(b => (b ? resolve(b) : reject(new Error("Blob conversion failed"))), "image/png"));
      }

      // --- Delete previous image if exists ---
      if (block.data?.imageRef?.id) {
        try {
          await deleteKiinteistoImage(block.data.imageRef.id); // remove from DB
          const oldCacheKey = getPtsKey(propertyId, block.data.imageRef.metadata.category, block.data.imageRef.id);
          await set(oldCacheKey, undefined); // remove from IndexedDB
          if (ptsImageUrls[oldCacheKey]) URL.revokeObjectURL(ptsImageUrls[oldCacheKey]);
          setPtsImageUrls(prev => ({ ...prev, [oldCacheKey]: undefined }));
          console.log(`[PTS] Deleted old image ${block.data.imageRef.id}`);
        } catch (err) {
          console.warn("Failed to delete old image:", err);
        }
      }

      // --- Generate a unique filename ---
      const fileName = `${propertyId}/${crypto.randomUUID()}-${showPart}.png`;

      // --- Create DB record ---
      const createdRecord = await createKiinteistoImage({
        id_kiinteisto: propertyId,
        azure_blob_name: fileName,
        metadata: { category: showPart, description: block.name, originalName: fileName },
        created_by: SYSTEM_USER_ID,
        updated_by: SYSTEM_USER_ID
      });

      const imageId = createdRecord.data.id;

      // --- Get SAS token and upload ---
      const sasResp = await getKiinteistoSasToken(fileName);
      const sasUrl = sasResp.data?.sasUrl;
      if (!sasUrl) throw new Error("SAS URL puuttuu backendistä");

      await fetch(sasUrl, { method: "PUT", headers: { "x-ms-blob-type": "BlockBlob", "Content-Type": "image/png" }, body: blob });

      // --- Update block data with new image ---
      const updatedData = {
        ...block.data,
        imageRef: { id: imageId, azure_blob_name: fileName, metadata: { category: showPart, description: block.name, originalName: fileName }, updated_at: new Date().toISOString() },
      };
      handleBlockChange(blockPath, updatedData);

      // --- Cache new blob ---
      const cacheKey = getPtsKey(propertyId, showPart, imageId);
      await set(cacheKey, blob);
      if (ptsImageUrls[cacheKey]) URL.revokeObjectURL(ptsImageUrls[cacheKey]);
      setPtsImageUrls(prev => ({ ...prev, [cacheKey]: URL.createObjectURL(blob) }));

      alert(`Kuva tallennettu (${showPart})!`);

    } catch (err) {
      console.error("Kuvan tallennus epäonnistui:", err);
      alert("Kuvan tallennus epäonnistui.");
    }
  };

  // useEffect(() => {
  //   const fetchKiinteistot = async () => {
  //     try {
  //       const res = await getKiinteistot();

  //       const list =
  //         Array.isArray(res.data)
  //           ? res.data
  //           : res.data.rows || res.data.data || [];

  //       setAvailableKiinteistot(list);
  //     } catch (err) {
  //       console.error("Failed to load kiinteistöt:", err);
  //     }
  //   };

  //   fetchKiinteistot();
  // }, []);




  useEffect(() => { if (activeSection) setSectionNameInput(activeSection.name || ""); }, [activeSection]);

  const handleSaveSectionName = async () => {
    try {
      await renameSection(activeSection.id, sectionNameInput);
      setEditingName(false);
    } catch {
      alert("Osion nimen tallennus epäonnistui.");
    }
  };



  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (saveTimeoutRef.current) clearTimeout(saveTimeoutRef.current);
      handleBlockBlur();
      if (unsavedChanges) { e.preventDefault(); e.returnValue = ''; }
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [content, unsavedChanges]);


  // const updatedAtFormatted = activeSection?.updated_at
  //   ? format(new Date(activeSection.updated_at), 'd.M.yyyy HH:mm', { locale: fi })
  //   : null;

  // Detect multiple map blocks in this section
  const hasMapBlock = (blocks) =>
    blocks.some(b =>
      b.type === "MapBlock" || b.type === "MapBlock2" ||
      (b.type === "subsection" && hasMapBlock(b.data.blocks))
    );

  function getParentSubsectionTitle(blocks, blockPath) {
    let currentBlocks = blocks;
    let parentTitle = "";

    for (let depth = 0; depth < blockPath.length; depth++) {
      const index = blockPath[depth];
      const block = currentBlocks[index];

      if (!block) break;

      // If this block is a subsection, update parentTitle
      if (block.type === "subsection" || block.type === "subsection2") {
        parentTitle = block.data?.title || "";
        currentBlocks = block.data?.blocks || [];
      } else {
        // Normal block → stop descending
        break;
      }
    }

    return parentTitle;
  }


const handleCreateApartmentCards =
  useCallback(
    async (apartments) => {

      // ---------------------------------------------------
      // VALIDATE
      // ---------------------------------------------------

      if (
        !Array.isArray(
          apartments
        ) ||
        apartments.length ===
          0
      ) {

        alert(
          "Valitse vähintään yksi huoneisto."
        );

        return;

      }


      // ---------------------------------------------------
      // FIND LÄMPÖKAMERAKUVAUKSET
      // ---------------------------------------------------

      const lampoSection =
        sections.find(
          (section) => {

            const name =
              (
                section.name ||
                ""
              )
                .trim()
                .toLowerCase();


            return (
              name ===
              "lämpökamerakuvaukset"
            );

          }
        );


      if (!lampoSection) {

        alert(
          "Lämpökamerakuvaukset-osiota ei löytynyt."
        );


        console.error(
          "Lämpökamerakuvaukset section not found:",
          sections.map(
            (s) => ({
              id:
                s.id,

              name:
                s.name,

              type:
                s.type,
            })
          )
        );


        return;

      }


      // ---------------------------------------------------
      // READ CURRENT CONTENT
      // ---------------------------------------------------

      let lampoContent;


      try {

        lampoContent =
          typeof lampoSection.content ===
          "string"

            ? JSON.parse(
                lampoSection.content
              )

            : structuredClone(
                lampoSection.content ||
                  {
                    blocks:
                      [],
                  }
              );


      } catch (err) {

        console.error(
          "Lämpökamerakuvaukset content JSON parse failed:",
          err
        );


        alert(
          "Lämpökamerakuvaukset-osion sisältöä ei voitu lukea."
        );


        return;

      }


      if (
        !Array.isArray(
          lampoContent.blocks
        )
      ) {

        lampoContent.blocks =
          [];

      }


      // ---------------------------------------------------
      // REMOVE OLD GENERATED APARTMENT CARDS
      //
      // This means pressing "Luo huoneistokortit"
      // again rebuilds only these generated cards.
      // Other manually created blocks remain untouched.
      // ---------------------------------------------------

      lampoContent.blocks =
        lampoContent.blocks.filter(
          (block) =>
            !block.data
              ?.generatedHuoneistoKortti
        );


      // ---------------------------------------------------
      // CREATE APARTMENTS
      // ---------------------------------------------------

      const apartmentBlocks =
        apartments.map(
          (apartment) => {

            const apartmentName =
              apartment.name
                ?.trim();


            const rooms =
              Array.isArray(
                apartment.rooms
              )
                ? apartment.rooms.filter(
                    (room) =>
                      room.name
                        ?.trim()
                  )
                : [];


            // -----------------------------------------------
            // ONE LÄMPÖKAMERAKORTTI FOR EACH ROOM
            // -----------------------------------------------

            const roomBlocks =
              rooms.map(
                (
                  room,
                  roomIndex
                ) => {

                  const roomName =
                    room.name.trim();


                  return {

                    id:
                      createBlockId(),


                    type:
                      "LampokameraKorttiBlock",


                    name:
                      `Lämpökamerakortti – ${roomName}`,


                    data: {

                      // -------------------------------------
                      // CONNECTION
                      // -------------------------------------

                      huoneisto:
                        apartmentName,

                      apartment:
                        apartmentName,

                      apartmentId:
                        apartment.id ||
                        null,


                      room:
                        roomName,

                      roomId:
                        room.id ||
                        null,

                      roomIndex:
                        roomIndex,


                      generatedHuoneistoKortti:
                        true,

                      generatedHuone:
                        true,


                      // -------------------------------------
                      // IMAGES
                      // -------------------------------------

                      thermalImage:
                        null,

                      normalImage:
                        null,


                      // -------------------------------------
                      // TEMPERATURE INDEX
                      // -------------------------------------

                      correctedTemperatureIndex:
                        "",

                      temperatureIndex:
                        "",


                      // -------------------------------------
                      // MEASUREMENTS
                      // -------------------------------------

                      minAreaTemperature:
                        "",

                      pointTemperature:
                        "",

                      pressureDifference:
                        "",

                      indoorTemperature:
                        "",


                      // -------------------------------------
                      // CAMERA SETTINGS
                      // -------------------------------------

                      emissivity:
                        "0,95",

                      reflectedTemperature:
                        "",

                      distance:
                        "",


                      // -------------------------------------
                      // OUTDOOR CONDITIONS
                      //
                      // No WeatherBlock is generated here.
                      // These are kept only because the
                      // LampokameraKorttiBlock currently
                      // has these data fields.
                      // -------------------------------------

                      outdoorTemperature:
                        "",

                      windSpeed:
                        "",

                      windDirection:
                        "",

                      cloudiness:
                        "",


                      // -------------------------------------
                      // COMMENTS
                      // -------------------------------------

                      comments:
                        "",

                    },

                  };

                }
              );


            // -----------------------------------------------
            // APARTMENT SUBSECTION
            // -----------------------------------------------

            return {

              id:
                createBlockId(),


              type:
                "subsection",


              name:
                "Huoneistokortti",


              data: {

                title:
                  `ASUNTO ${apartmentName}`,


                generatedHuoneistoKortti:
                  true,


                huoneisto:
                  apartmentName,


                apartmentId:
                  apartment.id ||
                  null,


                pageBreakBefore:
                  true,


                /*
                 * IMPORTANT:
                 *
                 * All room cards are children
                 * of this apartment.
                 *
                 * NO WeatherBlock here.
                 */
                blocks:
                  roomBlocks,

              },

            };

          }
        );


      // ---------------------------------------------------
      // ADD TO LÄMPÖKAMERAKUVAUKSET
      // ---------------------------------------------------

      lampoContent.blocks.push(
        ...apartmentBlocks
      );


      console.log(
        "🔥 Generated apartment/room cards:",
        apartmentBlocks
      );


      console.log(
        "🔥 Saving Lämpökamerakuvaukset:",
        lampoSection.id,
        lampoContent
      );


      // ---------------------------------------------------
      // SAVE THE OTHER SECTION
      // ---------------------------------------------------

      const success =
        await updateOtherSectionContent(
          lampoSection.id,
          lampoContent
        );


      if (!success) {

        console.error(
          "❌ Huoneistokorttien tallennus epäonnistui."
        );


        alert(
          "Huoneistokorttien tallennus epäonnistui."
        );


        return;

      }


      // ---------------------------------------------------
      // RESULT COUNTS
      // ---------------------------------------------------

      const roomCount =
        apartments.reduce(
          (
            total,
            apartment
          ) =>
            total +
            (
              apartment.rooms ||
              []
            ).filter(
              (room) =>
                room.name
                  ?.trim()
            ).length,

          0
        );


      console.log(
        `✅ ${apartmentBlocks.length} huoneistoa, ${roomCount} huonekorttia tallennettu`
      );


      alert(
        `${apartmentBlocks.length} huoneistoa ja ${roomCount} huonekorttia luotu Lämpökamerakuvaukset-osioon.`
      );

    },

    [
      sections,
      updateOtherSectionContent,
    ]
  );
const handleAddApartmentRoom = useCallback(
  (blockPath, currentBlock, roomName) => {

    if (
      !Array.isArray(blockPath) ||
      blockPath.length < 2
    ) {
      console.error(
        "Room card is not inside an apartment subsection."
      );

      return;
    }


    const newContent =
      structuredClone(
        content
      );


    /*
     * blockPath example:
     *
     * [3, 0]
     *
     * 3 = ASUNTO A1 subsection
     * 0 = current LampokameraKorttiBlock
     *
     * We want to insert another block into
     * ASUNTO A1.data.blocks.
     */
    const parentPath =
      blockPath.slice(
        0,
        -1
      );


    let parentBlocks =
      newContent.blocks;


    let parentBlock =
      null;


    for (
      let depth = 0;
      depth <
      parentPath.length;
      depth++
    ) {

      const index =
        parentPath[depth];


      parentBlock =
        parentBlocks[index];


      if (!parentBlock) {

        console.error(
          "Parent apartment block not found.",
          blockPath
        );

        return;

      }


      if (
        depth <
        parentPath.length -
          1
      ) {

        parentBlocks =
          parentBlock.data
            ?.blocks;

      }

    }


    if (
      !parentBlock ||
      !Array.isArray(
        parentBlock.data
          ?.blocks
      )
    ) {

      console.error(
        "Apartment subsection has no blocks.",
        parentBlock
      );

      return;

    }


    /*
     * Only allow this special button
     * for generated apartment subsections.
     */
    if (
      !parentBlock.data
        ?.generatedHuoneistoKortti
    ) {

      console.error(
        "Parent is not a generated apartment card."
      );

      return;

    }


    const apartmentName =
      currentBlock.data
        ?.huoneisto ||
      currentBlock.data
        ?.apartment ||
      parentBlock.data
        ?.huoneisto ||
      "";


    const apartmentId =
      currentBlock.data
        ?.apartmentId ||
      parentBlock.data
        ?.apartmentId ||
      null;


    const newRoomBlock = {

      id:
        createBlockId(),


      type:
        "LampokameraKorttiBlock",


      name:
        `Lämpökamerakortti – ${roomName}`,


      data: {

        // Apartment connection
        huoneisto:
          apartmentName,

        apartment:
          apartmentName,

        apartmentId:
          apartmentId,


        // Room connection
        room:
          roomName,

        roomId:
          crypto.randomUUID(),

        roomIndex:
          parentBlock.data
            .blocks.filter(
              (b) =>
                b.type ===
                "LampokameraKorttiBlock"
            ).length,


        generatedHuoneistoKortti:
          true,

        generatedHuone:
          true,


        // Images
        thermalImage:
          null,

        normalImage:
          null,


        // Temperature index
        correctedTemperatureIndex:
          "",

        temperatureIndex:
          "",


        // Measurements
        minAreaTemperature:
          "",

        pointTemperature:
          "",

        pressureDifference:
          "",

        indoorTemperature:
          "",


        // Measurement parameters
        emissivity:
          "0,95",

        reflectedTemperature:
          "",

        distance:
          "",


        // Weather
        weather:
          {},


        // Comments
        comments:
          "",

      },

    };


    /*
     * Add as another child of
     * the SAME ASUNTO subsection.
     */
    parentBlock.data.blocks.push(
      newRoomBlock
    );


    /*
     * Persist the entire current
     * section content.
     */
    handleBlockBlur(
      newContent
    );

  },

  [
    content,
    handleBlockBlur,
  ]
);
const renderBlocks = (blocks = [], path = [], currentSubsectionTitle = "") => {
  if (!Array.isArray(blocks)) return null;

  return blocks.map((block, i) => {
    const blockPath = [...path, i];       // keep for mutations

    // When viewing a single subsection, skip all other top-level subsections so
    // the path index stays correct against the full content.blocks array.
    if (path.length === 0 && activeSubsectionId &&
        (block.type === 'subsection' || block.type === 'subsection2') &&
        block.id !== activeSubsectionId) {
      return null;
    }

    const key = `${versionKey}-${block.id ?? blockPath.join('-')}`; // prefer id, fallback for safety
    const isEditing = editingSubsections.has(block.id ?? key);
    // 🔍 Auto-detect systemType based on section name
    let systemType = "default";
    const sectionName = activeSection?.name?.toLowerCase() || "";
    const hasPtsChild = block.data?.blocks?.some(
    b => b.type?.startsWith("PtsBlock")
  );
    if (sectionName.includes("lvi")) systemType = "LVI";
    else if (sectionName.includes("sähkö")) systemType = "sähkö";
    else if (sectionName.includes("rakenne")) systemType = "rakennetekniikka";

    if (block.type === "subsection2") {
      return (
        <div key={key} id={`subsection-${block.id}`} className="rounded p-0 mb-3 bg-white" style={{ scrollMarginTop: 48, border: "2px solid #adb5bd" }}>
          {/* Wrapper gives position:relative for the settings popup without joining the transform stacking context */}
          <div style={{ position: 'relative' }}>
            {/* Full-width GREY banner */}
            <div
              className="d-flex align-items-center w-100 p-2 rounded-top subsection-header-title"
              style={{
                cursor: "default",
                fontSize: uiSettings.headerFontSize,
                backgroundColor: "rgba(233, 236, 239, 0.95)",
                color: "#212529",
                boxShadow: "0 8px 16px rgba(0,0,0,0.25)",
                fontWeight: 600,
                letterSpacing: "0.4px",
                transition: "transform 0.2s, box-shadow 0.2s",
              }}
              onMouseEnter={e => {
                e.currentTarget.style.transform = "translateY(-2px)";
                e.currentTarget.style.boxShadow = "0 12px 24px rgba(0,0,0,0.3)";
              }}
              onMouseLeave={e => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 8px 16px rgba(0,0,0,0.25)";
              }}
            >
              {/* Title + Edit icon */}
              <div className="d-flex align-items-center flex-wrap ms-3" style={{ gap: "0.5rem", flexGrow: 1 }}>
                {isEditing ? (
                  <SubsectionTitleInput
                    className="form-control form-control-sm"
                    value={block.data.title}
                    onCommit={(newTitle) => {
                      handleBlockChange(blockPath, { ...block.data, title: newTitle });
                      toggleEditingSubsection(block.id);
                    }}
                  />
                ) : (
                  <>
                    <span>{block.data.title}</span>
                    <Edit
                      size={18}
                      style={{ color: "#495057" }}
                      onClick={() => toggleEditingSubsection(block.id)}
                    />
                  </>
                )}
              </div>

              {/* Settings cog — button only, popup is a sibling outside the transform */}
              <button
                title="Asetukset"
                style={{ padding: '4px', borderRadius: 4, background: 'rgba(0,0,0,0.12)', border: 'none', color: '#495057', lineHeight: 1, display: 'flex', alignItems: 'center' }}
                onClick={e => { e.stopPropagation(); setOpenSettings(p => p === block.id ? null : block.id); }}
              >
                <Settings size={14} />
              </button>

              {/* Edit mode controls */}
              {editMode && (
                <div
                  className="d-flex align-items-center flex-wrap px-2 py-1 rounded"
                  style={{ gap: "0.5rem", background: "rgba(0,0,0,0.08)" }}
                >
                  <button className="btn btn-sm btn-light fw-bold" onClick={() => moveBlock(blockPath, "up")}>↑</button>
                  <button className="btn btn-sm btn-light fw-bold" onClick={() => moveBlock(blockPath, "down")}>↓</button>
                  <button className="btn btn-sm btn-outline-secondary fw-bold" onClick={() => handleCopyBlock(block)} title="Kopioi lohko">⎘</button>
                  <button className="btn btn-sm btn-danger fw-bold" onClick={() => handleDeleteBlock(blockPath)}>Poista</button>
                </div>
              )}
            </div>

            {/* Settings popup — sibling of the header, never inside its transform context */}
            {openSettings === block.id && (
              <>
                <div style={{ position: 'fixed', inset: 0, zIndex: 9000 }} onClick={() => setOpenSettings(null)} />
                <div className="dropdown-menu show" style={{ position: 'absolute', top: '100%', right: 0, zIndex: 9001, marginTop: 2, minWidth: 220 }}>
                  <div className="dropdown-header d-flex align-items-center justify-content-between">
                    <span>Asetukset — {blockRegistry[block.type]?.label || block.type}</span>
                    <button onClick={() => setOpenSettings(null)} style={{ background: 'none', border: 'none', color: '#dc3545', padding: '0 2px', lineHeight: 1, fontSize: '1rem', cursor: 'pointer' }}>✕</button>
                  </div>
                  <button
                    className="dropdown-item d-flex align-items-center gap-2"
                    onClick={() => togglePageBreak(block, blockPath)}
                  >
                    <input type="checkbox" className="form-check-input flex-shrink-0 mt-0" style={{pointerEvents:'none'}} checked={getPageBreak(block)} readOnly />
                    Pakota uudelle sivulle
                  </button>
                  <button
                    className="dropdown-item d-flex align-items-center gap-2"
                    onClick={() => toggleLandscape(block, blockPath)}
                  >
                    <input type="checkbox" className="form-check-input flex-shrink-0 mt-0" style={{pointerEvents:'none'}} checked={getLandscape(block)} readOnly />
                    Sivun kääntö vaakaan
                  </button>
                  {['PtsBlockRakennetekniikka', 'PtsBlockLVI', 'PtsBlockSahko', 'PtsBlockYhteenveto', 'PtsBlockTutkimukset'].includes(block.type) && (
                    <>
                      <div className="dropdown-divider" />
                      <div className="dropdown-header">PTS-taulukko</div>
                      <button
                        className="dropdown-item d-flex align-items-center gap-2"
                        onClick={() => handleBlockChange(blockPath, { ...block.data, showAlvZero: !block.data?.showAlvZero })}
                      >
                        <input type="checkbox" className="form-check-input flex-shrink-0 mt-0" style={{pointerEvents:'none'}} checked={!!block.data?.showAlvZero} readOnly />
                        Näytä ALV 0 %
                      </button>
                      {['PtsBlockRakennetekniikka', 'PtsBlockLVI', 'PtsBlockSahko'].includes(block.type) && (
                        <button
                          className="dropdown-item d-flex align-items-center gap-2"
                          onClick={() => handleBlockChange(blockPath, { ...block.data, hideKuntoluokka: !block.data?.hideKuntoluokka })}
                        >
                          <input type="checkbox" className="form-check-input flex-shrink-0 mt-0" style={{pointerEvents:'none'}} checked={!!block.data?.hideKuntoluokka} readOnly />
                          Piilota kuntoluokka (KL)
                        </button>
                      )}
                      <button
                        className="dropdown-item d-flex align-items-center gap-2"
                        onClick={() => handleBlockChange(blockPath, { ...block.data, hide11thYear: !block.data?.hide11thYear })}
                      >
                        <input type="checkbox" className="form-check-input flex-shrink-0 mt-0" style={{pointerEvents:'none'}} checked={!!block.data?.hide11thYear} readOnly />
                        Näytä vain 10 vuotta
                      </button>
                    </>
                  )}
                  {block.type === 'CapexYhteenvetoBlock' && (
                    <>
                      <div className="dropdown-divider" />
                      <div className="dropdown-header">Capex-yhteenveto</div>
                      <button
                        className="dropdown-item d-flex align-items-center gap-2"
                        onClick={() => handleBlockChange(blockPath, { ...block.data, hide11thYear: !block.data?.hide11thYear })}
                      >
                        <input type="checkbox" className="form-check-input flex-shrink-0 mt-0" style={{pointerEvents:'none'}} checked={!!block.data?.hide11thYear} readOnly />
                        Näytä vain 10 vuotta
                      </button>
                      <button
                        className="dropdown-item d-flex align-items-center gap-2"
                        onClick={() => handleBlockChange(blockPath, { ...block.data, alviton: !block.data?.alviton })}
                      >
                        <input type="checkbox" className="form-check-input flex-shrink-0 mt-0" style={{pointerEvents:'none'}} checked={!!block.data?.alviton} readOnly />
                        ALVITON
                      </button>
                    </>
                  )}
                  {block.type === 'ToimenpiteetTekstimuodossaBlock' && (
                    <>
                      <div className="dropdown-divider" />
                      <div className="dropdown-header">Toimenpiteet tekstimuodossa</div>
                      <button
                        className="dropdown-item d-flex align-items-center gap-2"
                        onClick={() => handleBlockChange(blockPath, { ...block.data, alviton: !block.data?.alviton })}
                      >
                        <input type="checkbox" className="form-check-input flex-shrink-0 mt-0" style={{pointerEvents:'none'}} checked={!!block.data?.alviton} readOnly />
                        ALVITON
                      </button>
                    </>
                  )}
                  {block.type === 'ImageBlock' && (
                    <>
                      <div className="dropdown-divider" />
                      <div className="dropdown-header">PDF-koko</div>
                      {/* 'rappausnayte' hidden for now (not deleted — the PDF layout itself still works, just not offered here) */}
                      {[['normal', 'Pieni'], ['large', 'Iso'], ['liite', 'Liite'], ['rappausnayte', 'Rappausnäyte']].filter(([val]) => val !== 'rappausnayte').map(([val, label]) => (
                        <button key={val} className="dropdown-item d-flex align-items-center gap-2"
                          onClick={() => handleBlockChange(blockPath, { ...block.data, pdfLayout: val })}>
                          <input type="radio" className="form-check-input flex-shrink-0 mt-0" style={{pointerEvents:'none'}} checked={(block.data?.pdfLayout ?? 'normal') === val} readOnly />
                          {label}
                        </button>
                      ))}
                      {block.data?.category && (
                        <>
                          <div className="dropdown-divider" />
                          <div className="dropdown-header">Aliluokat</div>
                          {[[false, 'Kaikki aliluokat'], [true, 'Vain valittu']].map(([val, label]) => (
                            <button key={String(val)} className="dropdown-item d-flex align-items-center gap-2"
                              onClick={() => handleBlockChange(blockPath, { ...block.data, subCategoryIsLocked: val })}>
                              <input type="radio" className="form-check-input flex-shrink-0 mt-0" style={{pointerEvents:'none'}} checked={(block.data?.subCategoryIsLocked || false) === val} readOnly />
                              {label}
                            </button>
                          ))}
                        </>
                      )}
                    </>
                  )}
                </div>
              </>
            )}
          </div>

          {/* Inner blocks */}
          <div className="p-1 p-md-3">
            {renderBlocks(block.data.blocks, blockPath)}
          </div>

          {/* Add component dropdown */}
          {editMode && (
            <Can permission={PERMISSIONS.REPORTS.EDIT}>
              <div className="my-2 d-flex justify-content-center align-items-center gap-2">
                <DropdownButton
                  id={`dropdown-lohko-${key}`}
                  title="+ Lisää komponentti"
                  variant="outline-primary"
                >
                  {Object.entries(categorizedBlockRegistry).map(([category, blocks]) => (
                    <React.Fragment key={category}>
                      <Dropdown.Header>{category}</Dropdown.Header>
                      {Object.entries(blocks).map(([type, { label }]) => (
                        <Dropdown.Item
                          key={type}
                          onClick={() => handleAddBlock(type, blockPath)}
                        >
                          {label}
                        </Dropdown.Item>
                      ))}
                      <Dropdown.Divider />
                    </React.Fragment>
                  ))}
                </DropdownButton>
                {copiedBlock && (
                  <button className="btn btn-sm btn-outline-success" onClick={() => handlePasteClipboardBlock(blockPath)} title={`Liitä: ${blockRegistry[copiedBlock.type]?.label ?? copiedBlock.type}`}>
                    ⎘ Liitä {blockRegistry[copiedBlock.type]?.label ?? copiedBlock.type}
                  </button>
                )}
              </div>
            </Can>
          )}
        </div>
      );
    }

    if (block.type === "subsection") {
      if (!isTemplateView && isSentinelTitle(block.data?.title)) return null;
     const newSubsectionTitle = block.data?.title || "";

      return (
        <div key={key} id={`subsection-${block.id}`} className="rounded p-0 mb-3 bg-white" style={{ scrollMarginTop: 48, border: "2px solid #04aa00" }}>
          {/* Wrapper gives position:relative for the settings popup without joining the transform stacking context */}
          <div style={{ position: 'relative' }}>
            {/* Full-width banner with title + controls */}
            <div
              className="d-flex align-items-center w-100 p-2 subsection-header-title"
              style={{
                cursor: "default",
                fontSize: uiSettings.headerFontSize,
                backgroundColor: "#04aa00",
                color: "#ffffff",
                textShadow: "1px 1px 2px rgba(0,0,0,0.6)",
                boxShadow: "0 8px 16px rgba(0,0,0,0.3)",
                fontWeight: 600,
                letterSpacing: "0.5px",
                transition: "transform 0.2s, box-shadow 0.2s",
                borderRadius: "0.375rem 0.375rem 0 0",
              }}
              onMouseEnter={e => {
                e.currentTarget.style.transform = "translateY(-2px)";
                e.currentTarget.style.boxShadow = "0 12px 24px rgba(0,0,0,0.35)";
              }}
              onMouseLeave={e => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 8px 16px rgba(0,0,0,0.3)";
              }}
            >
              {/* Title + Edit icon inline */}
              <div className="d-flex align-items-center flex-wrap ms-3" style={{ gap: '0.5rem', flexGrow: 1 }}>
                {isEditing ? (
                    <SubsectionTitleInput
                      className="form-control form-control-sm"
                      value={block.data.title}
                      onCommit={(newTitle) => {
                        handleBlockChange(blockPath, { ...block.data, title: newTitle });
                        toggleEditingSubsection(block.id);
                      }}
                    />
                ) : (
                  <>
                    <span>{subsectionNumMap[block.id] ? `${subsectionNumMap[block.id]} ${block.data.title}` : block.data.title}</span>
                    <Edit size={18} className="text-white" onClick={() => toggleEditingSubsection(block.id)} />
                  </>
                )}
              </div>

              {/* Settings cog — button only, popup is a sibling outside the transform */}
              <button
                title="Asetukset"
                style={{ padding: '4px', borderRadius: 4, background: 'rgba(0,0,0,0.2)', border: 'none', color: '#fff', lineHeight: 1, display: 'flex', alignItems: 'center' }}
                onClick={e => { e.stopPropagation(); setOpenSettings(p => p === block.id ? null : block.id); }}
              >
                <Settings size={14} />
              </button>

              {/* Optional controls on the right if editMode */}
              {editMode && (
                <div
                  className="d-flex align-items-center flex-wrap px-2 py-1 rounded"
                  style={{ gap: '0.5rem', background: 'rgba(0,0,0,0.25)', backdropFilter: 'blur(2px)' }}
                >
                  <button className="btn btn-sm btn-light fw-bold" onClick={() => moveBlock(blockPath, 'up')}>↑</button>
                  <button className="btn btn-sm btn-light fw-bold" onClick={() => moveBlock(blockPath, 'down')}>↓</button>
                  <button className="btn btn-sm btn-danger fw-bold" onClick={() => handleDeleteBlock(blockPath)}>Poista</button>
                </div>
              )}
            </div>

            {/* Settings popup — sibling of the header, never inside its transform context */}
            {openSettings === block.id && (
              <>
                <div style={{ position: 'fixed', inset: 0, zIndex: 9000 }} onClick={() => setOpenSettings(null)} />
                <div className="dropdown-menu show" style={{ position: 'absolute', top: '100%', right: 0, zIndex: 9001, marginTop: 2, minWidth: 220 }}>
                  <div className="dropdown-header d-flex align-items-center justify-content-between">
                    <span>Asetukset — {blockRegistry[block.type]?.label || block.type}</span>
                    <button onClick={() => setOpenSettings(null)} style={{ background: 'none', border: 'none', color: '#dc3545', padding: '0 2px', lineHeight: 1, fontSize: '1rem', cursor: 'pointer' }}>✕</button>
                  </div>
                  <button
                    className="dropdown-item d-flex align-items-center gap-2"
                    onClick={() => togglePageBreak(block, blockPath)}
                  >
                    <input type="checkbox" className="form-check-input flex-shrink-0 mt-0" style={{pointerEvents:'none'}} checked={getPageBreak(block)} readOnly />
                    Pakota uudelle sivulle
                  </button>
                  <button
                    className="dropdown-item d-flex align-items-center gap-2"
                    onClick={() => toggleLandscape(block, blockPath)}
                  >
                    <input type="checkbox" className="form-check-input flex-shrink-0 mt-0" style={{pointerEvents:'none'}} checked={getLandscape(block)} readOnly />
                    Sivun kääntö vaakaan
                  </button>
                  {['PtsBlockRakennetekniikka', 'PtsBlockLVI', 'PtsBlockSahko', 'PtsBlockYhteenveto', 'PtsBlockTutkimukset'].includes(block.type) && (
                    <>
                      <div className="dropdown-divider" />
                      <div className="dropdown-header">PTS-taulukko</div>
                      <button
                        className="dropdown-item d-flex align-items-center gap-2"
                        onClick={() => handleBlockChange(blockPath, { ...block.data, showAlvZero: !block.data?.showAlvZero })}
                      >
                        <input type="checkbox" className="form-check-input flex-shrink-0 mt-0" style={{pointerEvents:'none'}} checked={!!block.data?.showAlvZero} readOnly />
                        Näytä ALV 0 %
                      </button>
                      {['PtsBlockRakennetekniikka', 'PtsBlockLVI', 'PtsBlockSahko'].includes(block.type) && (
                        <button
                          className="dropdown-item d-flex align-items-center gap-2"
                          onClick={() => handleBlockChange(blockPath, { ...block.data, hideKuntoluokka: !block.data?.hideKuntoluokka })}
                        >
                          <input type="checkbox" className="form-check-input flex-shrink-0 mt-0" style={{pointerEvents:'none'}} checked={!!block.data?.hideKuntoluokka} readOnly />
                          Piilota kuntoluokka (KL)
                        </button>
                      )}
                      <button
                        className="dropdown-item d-flex align-items-center gap-2"
                        onClick={() => handleBlockChange(blockPath, { ...block.data, hide11thYear: !block.data?.hide11thYear })}
                      >
                        <input type="checkbox" className="form-check-input flex-shrink-0 mt-0" style={{pointerEvents:'none'}} checked={!!block.data?.hide11thYear} readOnly />
                        Näytä vain 10 vuotta
                      </button>
                    </>
                  )}
                  {block.type === 'CapexYhteenvetoBlock' && (
                    <>
                      <div className="dropdown-divider" />
                      <div className="dropdown-header">Capex-yhteenveto</div>
                      <button
                        className="dropdown-item d-flex align-items-center gap-2"
                        onClick={() => handleBlockChange(blockPath, { ...block.data, hide11thYear: !block.data?.hide11thYear })}
                      >
                        <input type="checkbox" className="form-check-input flex-shrink-0 mt-0" style={{pointerEvents:'none'}} checked={!!block.data?.hide11thYear} readOnly />
                        Näytä vain 10 vuotta
                      </button>
                      <button
                        className="dropdown-item d-flex align-items-center gap-2"
                        onClick={() => handleBlockChange(blockPath, { ...block.data, alviton: !block.data?.alviton })}
                      >
                        <input type="checkbox" className="form-check-input flex-shrink-0 mt-0" style={{pointerEvents:'none'}} checked={!!block.data?.alviton} readOnly />
                        ALVITON
                      </button>
                    </>
                  )}
                  {block.type === 'ToimenpiteetTekstimuodossaBlock' && (
                    <>
                      <div className="dropdown-divider" />
                      <div className="dropdown-header">Toimenpiteet tekstimuodossa</div>
                      <button
                        className="dropdown-item d-flex align-items-center gap-2"
                        onClick={() => handleBlockChange(blockPath, { ...block.data, alviton: !block.data?.alviton })}
                      >
                        <input type="checkbox" className="form-check-input flex-shrink-0 mt-0" style={{pointerEvents:'none'}} checked={!!block.data?.alviton} readOnly />
                        ALVITON
                      </button>
                    </>
                  )}
                  {block.type === 'ImageBlock' && (
                    <>
                      <div className="dropdown-divider" />
                      <div className="dropdown-header">PDF-koko</div>
                      {/* 'rappausnayte' hidden for now (not deleted — the PDF layout itself still works, just not offered here) */}
                      {[['normal', 'Pieni'], ['large', 'Iso'], ['liite', 'Liite'], ['rappausnayte', 'Rappausnäyte']].filter(([val]) => val !== 'rappausnayte').map(([val, label]) => (
                        <button key={val} className="dropdown-item d-flex align-items-center gap-2"
                          onClick={() => handleBlockChange(blockPath, { ...block.data, pdfLayout: val })}>
                          <input type="radio" className="form-check-input flex-shrink-0 mt-0" style={{pointerEvents:'none'}} checked={(block.data?.pdfLayout ?? 'normal') === val} readOnly />
                          {label}
                        </button>
                      ))}
                      {block.data?.category && (
                        <>
                          <div className="dropdown-divider" />
                          <div className="dropdown-header">Aliluokat</div>
                          {[[false, 'Kaikki aliluokat'], [true, 'Vain valittu']].map(([val, label]) => (
                            <button key={String(val)} className="dropdown-item d-flex align-items-center gap-2"
                              onClick={() => handleBlockChange(blockPath, { ...block.data, subCategoryIsLocked: val })}>
                              <input type="radio" className="form-check-input flex-shrink-0 mt-0" style={{pointerEvents:'none'}} checked={(block.data?.subCategoryIsLocked || false) === val} readOnly />
                              {label}
                            </button>
                          ))}
                        </>
                      )}
                    </>
                  )}
                </div>
              </>
            )}
          </div>

          {/* Inner blocks */}
          <div className="p-1 p-md-3">
            {renderBlocks(block.data.blocks, blockPath, newSubsectionTitle)}
          </div>

          {/* Add component dropdown */}
          {editMode && (
            <div className="my-2 d-flex justify-content-center align-items-center gap-2">
              <DropdownButton
                id={`dropdown-lohko-${key}`}
                title="+ Lisää komponentti"
                variant="outline-primary"
              >
                {Object.entries(categorizedBlockRegistry).map(([category, blocks]) => (
                  <React.Fragment key={category}>
                    <Dropdown.Header>{category}</Dropdown.Header>
                    {Object.entries(blocks).map(([type, { label }]) => (
                      <Dropdown.Item
                        key={type}
                        onClick={() => handleAddBlock(type, blockPath)}
                      >
                        {label}
                      </Dropdown.Item>
                    ))}
                    <Dropdown.Divider />
                  </React.Fragment>
                ))}
              </DropdownButton>
              {copiedBlock && (
                <button className="btn btn-sm btn-outline-success" onClick={() => handlePasteClipboardBlock(blockPath)} title={`Liitä: ${blockRegistry[copiedBlock.type]?.label ?? copiedBlock.type}`}>
                  ⎘ Liitä {blockRegistry[copiedBlock.type]?.label ?? copiedBlock.type}
                </button>
              )}
            </div>
          )}
        </div>
      );
    }


    const config = blockRegistry[block.type];
    const BlockComp = config?.component;
    const isNoBlur = config?.noBlur;

    if (!BlockComp) return (
      <div key={key} className="mb-3 border p-2 rounded bg-warning text-dark">
        <strong>Tuntematon komponentti: {block.type}</strong>
        <button className="btn btn-sm btn-outline-danger ms-2" onClick={() => handleDeleteBlock(blockPath)}>Poista</button>
      </div>
    );

    if ((block.type === "MapBlock" || block.type === "MapBlock2") &&
      hasMapBlock(content.blocks.filter((_, idx) => idx < i))) {
        return (
          <div key={key} className="alert alert-warning">
            <strong>Vain yksi karttakomponentti sallittu per osio.</strong>
            <button
              className="btn btn-sm btn-outline-danger ms-2"
              onClick={() => handleDeleteBlock(blockPath)}
            >
              Poista ylimääräinen
            </button>
          </div>
        );
      }

      const effectivePropertyId =
        block.type === "propertyInfo"
          ? kiinteisto?.id_kiinteisto   
          : undefined;

      return (

        <div
          key={key}
          className="mb-3 border p-1 p-md-2 rounded bg-light shadow-sm"
          style={{
            filter: popup && !isNoBlur ? "blur(4px)" : "none",
            position: 'relative',
            zIndex: popup && isNoBlur ? 10000 : "auto",
          }}
        >
          {/* Universal settings popup */}
          {openSettings === block.id && (
            <>
              <div style={{ position: 'fixed', inset: 0, zIndex: 9000 }} onClick={() => setOpenSettings(null)} />
              <div className="dropdown-menu show" style={{ position: 'absolute', top: 2, right: 2, zIndex: 9001, minWidth: 220 }}>
                <div className="dropdown-header d-flex align-items-center justify-content-between">
                  <span>Asetukset — {blockRegistry[block.type]?.label || block.type}</span>
                  <button onClick={() => setOpenSettings(null)} style={{ background: 'none', border: 'none', color: '#dc3545', padding: '0 2px', lineHeight: 1, fontSize: '1rem', cursor: 'pointer' }}>✕</button>
                </div>
                <button
                  className="dropdown-item d-flex align-items-center gap-2"
                  onClick={() => togglePageBreak(block, blockPath)}
                >
                  <input type="checkbox" className="form-check-input flex-shrink-0 mt-0" checked={getPageBreak(block)} readOnly />
                  Pakota uudelle sivulle
                </button>
                <button
                  className="dropdown-item d-flex align-items-center gap-2"
                  onClick={() => toggleLandscape(block, blockPath)}
                >
                  <input type="checkbox" className="form-check-input flex-shrink-0 mt-0" checked={getLandscape(block)} readOnly />
                  Sivun kääntö vaakaan
                </button>
                {['PtsBlockRakennetekniikka', 'PtsBlockLVI', 'PtsBlockSahko', 'PtsBlockYhteenveto', 'PtsBlockTutkimukset'].includes(block.type) && (
                  <>
                    <div className="dropdown-divider" />
                    <div className="dropdown-header">PTS-taulukko</div>
                    <button
                      className="dropdown-item d-flex align-items-center gap-2"
                      onClick={() => handleBlockChange(blockPath, { ...block.data, showAlvZero: !block.data?.showAlvZero })}
                    >
                      <input type="checkbox" className="form-check-input flex-shrink-0 mt-0" checked={!!block.data?.showAlvZero} readOnly />
                      Näytä ALV 0 %
                    </button>
                    {['PtsBlockRakennetekniikka', 'PtsBlockLVI', 'PtsBlockSahko'].includes(block.type) && (
                      <button
                        className="dropdown-item d-flex align-items-center gap-2"
                        onClick={() => handleBlockChange(blockPath, { ...block.data, hideKuntoluokka: !block.data?.hideKuntoluokka })}
                      >
                        <input type="checkbox" className="form-check-input flex-shrink-0 mt-0" checked={!!block.data?.hideKuntoluokka} readOnly />
                        Piilota kuntoluokka (KL)
                      </button>
                    )}
                    <button
                      className="dropdown-item d-flex align-items-center gap-2"
                      onClick={() => handleBlockChange(blockPath, { ...block.data, hide11thYear: !block.data?.hide11thYear })}
                    >
                      <input type="checkbox" className="form-check-input flex-shrink-0 mt-0" checked={!!block.data?.hide11thYear} readOnly />
                      Näytä vain 10 vuotta
                    </button>
                  </>
                )}
                {block.type === 'CapexYhteenvetoBlock' && (
                  <>
                    <div className="dropdown-divider" />
                    <div className="dropdown-header">Capex-yhteenveto</div>
                    <button
                      className="dropdown-item d-flex align-items-center gap-2"
                      onClick={() => handleBlockChange(blockPath, { ...block.data, hide11thYear: !block.data?.hide11thYear })}
                    >
                      <input type="checkbox" className="form-check-input flex-shrink-0 mt-0" checked={!!block.data?.hide11thYear} readOnly />
                      Näytä vain 10 vuotta
                    </button>
                    <button
                      className="dropdown-item d-flex align-items-center gap-2"
                      onClick={() => handleBlockChange(blockPath, { ...block.data, alviton: !block.data?.alviton })}
                    >
                      <input type="checkbox" className="form-check-input flex-shrink-0 mt-0" checked={!!block.data?.alviton} readOnly />
                      ALVITON
                    </button>
                  </>
                )}
                {block.type === 'ToimenpiteetTekstimuodossaBlock' && (
                  <>
                    <div className="dropdown-divider" />
                    <div className="dropdown-header">Toimenpiteet tekstimuodossa</div>
                    <button
                      className="dropdown-item d-flex align-items-center gap-2"
                      onClick={() => handleBlockChange(blockPath, { ...block.data, alviton: !block.data?.alviton })}
                    >
                      <input type="checkbox" className="form-check-input flex-shrink-0 mt-0" checked={!!block.data?.alviton} readOnly />
                      ALVITON
                    </button>
                  </>
                )}
                {block.type === 'LexicalTextarea' && (
                  <>
                    <div className="dropdown-divider" />
                    <button className="dropdown-item d-flex align-items-center gap-2"
                      onClick={() => handleBlockChange(blockPath, { ...block.data, textRecommendationsEnabled: block.data?.textRecommendationsEnabled === false })}>
                      {/* !== false (not a plain truthy check) so every existing
                          block without this field set yet defaults to enabled —
                          matching current behavior for blocks that predate this toggle. */}
                      <input type="checkbox" className="form-check-input flex-shrink-0 mt-0" checked={block.data?.textRecommendationsEnabled !== false} readOnly />
                      Tekstisuositukset käytössä
                    </button>
                  </>
                )}
                {block.type === 'ImageBlock' && (
                  <>
                    <div className="dropdown-divider" />
                    <div className="dropdown-header">PDF-koko</div>
                    {/* 'rappausnayte' hidden for now (not deleted — the PDF layout itself still works, just not offered here) */}
                    {[['normal', 'Pieni'], ['large', 'Iso'], ['liite', 'Liite'], ['rappausnayte', 'Rappausnäyte']].filter(([val]) => val !== 'rappausnayte').map(([val, label]) => (
                      <button key={val} className="dropdown-item d-flex align-items-center gap-2"
                        onClick={() => handleBlockChange(blockPath, { ...block.data, pdfLayout: val })}>
                        <input type="radio" className="form-check-input flex-shrink-0 mt-0" style={{pointerEvents:'none'}} checked={(block.data?.pdfLayout ?? 'normal') === val} readOnly />
                        {label}
                      </button>
                    ))}
                    {block.data?.category && (
                      <>
                        <div className="dropdown-divider" />
                        <div className="dropdown-header">Aliluokat</div>
                        {[[false, 'Kaikki aliluokat'], [true, 'Vain valittu']].map(([val, label]) => (
                          <button key={String(val)} className="dropdown-item d-flex align-items-center gap-2"
                            onClick={() => handleBlockChange(blockPath, { ...block.data, subCategoryIsLocked: val })}>
                            <input type="radio" className="form-check-input flex-shrink-0 mt-0" style={{pointerEvents:'none'}} checked={(block.data?.subCategoryIsLocked || false) === val} readOnly />
                            {label}
                          </button>
                        ))}
                      </>
                    )}
                  </>
                )}
              </div>
            </>
          )}

          <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-1">
            {/* Top row: Name on left, settings + edit controls on right */}
            <div className="d-flex justify-content-between align-items-start mb-2 w-100">
              {/* Block name */}
              <strong className="block-name-label">{block.name}</strong>

              <div className="d-flex align-items-center gap-1 ms-1">
                {/* Settings cog */}
                <button
                  title="Asetukset"
                  style={{ padding: '3px', borderRadius: 4, background: 'transparent', border: '1px solid #dee2e6', color: '#6c757d', lineHeight: 1, display: 'flex', alignItems: 'center' }}
                  onClick={e => { e.stopPropagation(); setOpenSettings(p => p === block.id ? null : block.id); }}
                >
                  <Settings size={13} />
                </button>

                {/* Edit controls (move/delete) */}
                {editMode && (
                  <div className="d-flex flex-wrap" style={{ gap: '0.25rem' }}>
                    <button className="btn btn-sm btn-outline-secondary" onClick={() => moveBlock(blockPath, 'up')}>↑</button>
                    <button className="btn btn-sm btn-outline-secondary" onClick={() => moveBlock(blockPath, 'down')}>↓</button>
                    <button className="btn btn-sm btn-outline-secondary" onClick={() => handleCopyBlock(block)} title="Kopioi lohko">⎘</button>
                    <button className="btn btn-sm btn-outline-danger" onClick={() => handleDeleteBlock(blockPath)}>Poista</button>
                  </div>
                )}
              </div>
            </div>

          </div>

          {/* {block.data?.imageRef && renderPtsImage(block, kiinteistoId, ptsImageUrls)} */}

          {/* ✅ move ref *inside* here, around the block content only */}
      {/* <div ref={el => (blockRefs.current[key] = el)}> */}
      <div ref={el => (blockRefs.current[block.id] = el)}>
            

      {energiaTables && energiaIndexMap[block.type] !== undefined ? (
          <EnergiaBlockLinked
              block={energiaTables.data.blocks[energiaIndexMap[block.type]]}
              tableId={energiaTables.id}
              onSaveBlock={(updatedBlock) =>
                  handleEnergiaSave(energiaIndexMap[block.type], updatedBlock)
              }
      />
          ) : (
            <BlockComp
              key={`${blockPath.join("-")}${activeSectionId}`}
              data={
                linkedProjectId &&
                ['PeitepaksuusBlock', 'VetolujuusBlock', 'OhuthieBlock', 'KloridipitoisuusBlock', 'PoranayteBlock'].includes(block.type) &&
                block.data?.ptsProjectId !== linkedProjectId
                  ? { ...block.data, ptsProjectId: linkedProjectId, mittausProjektiId: null }
                  : block.data
              }
              onCreateApartments={
  block.type === "HuoneistoKortitBlock"
    ? handleCreateApartmentCards
    : undefined
}
onAddRoom={
  block.type === "LampokameraKorttiBlock"
    ? (roomName) =>
        handleAddApartmentRoom(
          blockPath,
          block,
          roomName
        )
    : undefined
}
              onChange={(newData) => handleBlockChangeMemo(blockPath, newData, block.id)}
              blockPath={blockPath}
              blockId={block.id}
              // Full cross-report matching path for text recommendations —
              // the subsection trail plus this specific textarea's own
              // label, exactly what reportLlmExtract.js's findBlock expects
              // as its path fallback (subsectionTitle alone only ever
              // matches the whole subsection, pulling in its toimenpiteet/
              // images too — see the comment on textLabelFor above).
              blockPathLabel={
                block.type === 'LexicalTextarea'
                  ? [currentSubsectionTitle, textLabelFor(block, blocks, i)].filter(Boolean).join(PATH_SEP)
                  : undefined
              }
              systemType={systemType}
              subsectionTitle={currentSubsectionTitle || activeSection?.name}
              card={mergedRakennusData ?? kiinteisto}
                kiinteisto={kiinteisto}
              API_URL={config.API_URL}
              tableStartNumber={tableNumberMap.get(block.id) ?? 1}
              {...(block.type === 'PoranayteBlock' ? { onSyncRow: syncPoranayteRow } : {})}
              {...(['PeitepaksuusBlock', 'VetolujuusBlock', 'OhuthieBlock', 'KloridipitoisuusBlock'].includes(block.type) ? { onCreateNayte: createNayteForSection } : {})}
              {...(['PoranayteBlock', 'OhuthieBlock', 'VetolujuusBlock', 'KloridipitoisuusBlock'].includes(block.type)
                ? { allViewValue: getAllView(block), onSetAllView: v => setAllView(block, blockPath, v) }
                : {})}
            />
          )}

        
          </div>
        </div>
      );

  });
};


  if (!activeSection) return <div className="p-3">Valitse osio sivupalkista.</div>;
  if (!isTemplateView && isSentinelSection(activeSection)) return <div className="p-3">Valitse osio sivupalkista.</div>;


  return (
    <>
    <div className="p-0 report" style={{ position: 'relative' }}>
      {/* Popup overlays */}
      {popup && (
        <>
          <div style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", backgroundColor: "rgba(0,0,0,0.3)", zIndex: 9998 }} />
          <div style={{ position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)", padding: "2rem 3rem", backgroundColor: "rgba(186,59,70,0.95)", color: "white", fontSize: "1.25rem", fontWeight: "bold", borderRadius: 12, zIndex: 9999, boxShadow: "0 8px 24px rgba(0,0,0,0.4)", textAlign: "center", maxWidth: "80%", pointerEvents: "auto" }}>
            {popup.message}
          </div>
        </>
      )}

{/* ── Section header ── */}
{/* ── Section header card ── */}
{/* Quieted: every block in the report builder gets this same header, so
    its visual weight was competing with each block's own content below
    it — a thick colored left-border + bottom rule + solid-filled number
    pill read as its own prominent "card" rather than a label. One
    hairline divider now does the separating; the number pill is a plain
    muted number instead of a filled green badge. headerFontSize stays
    untouched — it's a user-configurable report display setting (also
    drives the PDF output), not something to override here. */}
<div style={{
  paddingBottom: 8,
  marginBottom: 14,
  borderBottom: '1px solid #e5e5ea',
}}>

  {editingName ? (
    /* Rename mode */
    <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap', padding: '4px 0' }}>
      <input
        type="text"
        className="form-control form-control-sm"
        style={{ maxWidth: 400, flexGrow: 1 }}
        value={sectionNameInput}
        onChange={(e) => setSectionNameInput(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') handleSaveSectionName();
          if (e.key === 'Escape') setEditingName(false);
        }}
        autoFocus
      />
      <button className="btn btn-sm btn-success" onClick={handleSaveSectionName}>Tallenna</button>
      <button className="btn btn-sm btn-outline-secondary" onClick={() => setEditingName(false)}>Peru</button>
    </div>
  ) : (
    <>
      {/* ── Row 1: number + title + icons ── */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, minWidth: 0, flexWrap: 'wrap' }}>

        {currentSectionNum > 0 && (
          <span style={{
            flexShrink: 0,
            color: '#adb5bd',
            fontWeight: 600,
            fontSize: '0.78rem',
            lineHeight: 1,
          }}>
            {currentSectionNum}
          </span>
        )}

        <h4 style={{
          margin: 0,
          fontWeight: 600,
          fontSize: uiSettings.headerFontSize,
          lineHeight: 1.2,
          wordBreak: 'break-word',
          flexGrow: 1,
          color: '#212529',
        }}>
          {activeSection.name}
        </h4>

        <Can permission={PERMISSIONS.REPORTS.EDIT}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 1, flexShrink: 0 }}>
            <button
              title="Muokkaa nimeä"
              onClick={() => setEditingName(true)}
              style={{ background: 'none', border: 'none', padding: '4px 5px', cursor: 'pointer', color: '#6c757d', borderRadius: 4, display: 'flex', alignItems: 'center' }}
              onMouseEnter={e => e.currentTarget.style.color = '#212529'}
              onMouseLeave={e => e.currentTarget.style.color = '#6c757d'}
            >
              <Edit size={15} />
            </button>
            {!isTemplateView && (
              <button
                title="Osion toiminnot"
                onClick={() => setShowTemplateModal(true)}
                style={{ background: 'none', border: 'none', padding: '4px 5px', cursor: 'pointer', color: '#6c757d', borderRadius: 4, display: 'flex', alignItems: 'center' }}
                onMouseEnter={e => e.currentTarget.style.color = '#212529'}
                onMouseLeave={e => e.currentTarget.style.color = '#6c757d'}
              >
                <Settings size={15} />
              </button>
            )}
          </div>
        </Can>
      </div>

      {/* ── Row 2: property info ── */}
      {!isTemplateView && kiinteisto?.rakennukset_fulls?.[0] && (
        <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '2px 8px', marginTop: 5, fontSize: '0.73rem', color: '#6c757d' }}>
          <span>
            {kiinteisto.rakennukset_fulls[0].osoite || '–'}
            {kiinteisto.rakennukset_fulls[0].toimipaikka ? `, ${kiinteisto.rakennukset_fulls[0].toimipaikka}` : ''}
          </span>
          <span style={{ color: '#dee2e6' }}>·</span>
          <span>{kiinteisto.kiinteistotunnus || '–'}</span>
          <span style={{ color: '#dee2e6' }}>·</span>
          <PdfReadyImagesChecker propertyId={kiinteistoId} />
        </div>
      )}

      {/* ── Row 3: last edited ── */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 4, marginTop: 6 }}>
        <Clock size={11} color="#adb5bd" style={{ flexShrink: 0 }} />
        <SectionLastEdited updatedBy={activeSection.updated_by} updatedAt={activeSection.updated_at} />
      </div>
    </>
  )}

  {/* Section actions modal */}
  <Modal show={showTemplateModal} onHide={() => setShowTemplateModal(false)} centered size="sm">
    <Modal.Header closeButton>
      <Modal.Title style={{ fontSize: '1rem' }}>Osion toiminnot</Modal.Title>
    </Modal.Header>
    <Modal.Body className="d-flex flex-column gap-2">
      <button
        className="btn btn-outline-success d-flex align-items-center justify-content-center gap-2"
        onClick={() => {
          setShowTemplateModal(false);
          confirmAndRun({
            title: "Päivitä osio mallista?",
            message: "Tämä korvaa osion sisällön mallin mukaiseksi.\n\nLISÄTTY SISÄLTÖ HÄVIÄÄ!",
            confirmText: "Päivitä mallista",
            action: () => updateSectionFromTemplate(availablePTSSections),
          });
        }}
      >
        <i className="bi bi-arrow-clockwise"></i>
        Päivitä mallista
      </button>
      <button
        className="btn btn-outline-success d-flex align-items-center justify-content-center gap-2"
        onClick={() => { setShowTemplateModal(false); setShowVersions(true); }}
      >
        <i className="bi bi-file-diff-fill"></i>
        Versiot
      </button>
    </Modal.Body>
  </Modal>
</div>

      

    <SectionActions
      isTemplateView={isTemplateView}
      availablePTSSections={availablePTSSections}
      updateSectionFromTemplate={updateSectionFromTemplate}
      setShowVersions={setShowVersions}
      readiness={readiness}
      onReadinessChange={handleReadinessChange}
      showReadiness={showReadiness}
    />

    {/* SubsectionNav pill bar hidden — navigation moved to sidebar */}

    <div className="report-section-content">
      {renderBlocks(content.blocks || [])}
    </div>



      {/* Add block dropdown */}
        {editMode && (
          <Can permission={PERMISSIONS.REPORTS.EDIT}>
            <div className="mt-3 d-flex align-items-center gap-2">
              <div style={{ flex: 1 }}>
                <Dropdown>
                  <Dropdown.Toggle className="w-100" variant="outline-primary">
                    Lisää komponentti
                  </Dropdown.Toggle>

                  <Dropdown.Menu className="w-100">
                    {Object.entries(categorizedBlockRegistry).map(([category, blocks]) => (
                      <React.Fragment key={category}>
                        <Dropdown.Header>{category}</Dropdown.Header>
                        {Object.entries(blocks).map(([type, { label }]) => (
                          <Dropdown.Item key={type} onClick={() => handleAddBlock(type)}>
                            {label}
                          </Dropdown.Item>
                        ))}
                        <Dropdown.Divider />
                      </React.Fragment>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              </div>
              {copiedBlock && (
                <button className="btn btn-outline-success" onClick={() => handlePasteClipboardBlock()} title={`Liitä: ${blockRegistry[copiedBlock.type]?.label ?? copiedBlock.type}`}>
                  ⎘ Liitä {blockRegistry[copiedBlock.type]?.label ?? copiedBlock.type}
                </button>
              )}
            </div>
          </Can>
        )}

    {/* <RegularDropdown></RegularDropdown> */}



      <SectionVersionsGetter show={showVersions} onClose={() => setShowVersions(false)}/>

      
      {editMode && <div className="mt-4 border-top pt-2">
        <label className="d-flex align-items-center gap-2 text-muted" style={{ fontSize: '0.75rem', cursor: 'pointer' }}>
          <input type="checkbox" checked={showDebugJson} onChange={e => setShowDebugJson(e.target.checked)} />
          Näytä JSON-rakenne
        </label>
        {showDebugJson && (
          <>
            <pre className="mt-2 p-2 bg-light border rounded" style={{ fontSize: '0.72rem', maxHeight: 400, overflowY: 'auto' }}>
              {JSON.stringify(
                activeSubsectionId
                  ? { blocks: (content.blocks || []).filter(b => b.id === activeSubsectionId) }
                  : content,
                null, 2
              )}
            </pre>
            <div className="mt-2">
              <div className="text-muted mb-1" style={{ fontSize: '0.72rem' }}>Liitä lohko JSON:sta (yksittäinen block-objekti tai {"{ blocks: [...] }"})</div>
              <textarea
                className="form-control form-control-sm font-monospace"
                rows={5}
                style={{ fontSize: '0.7rem' }}
                placeholder='{ "type": "subsection", "data": { ... } }'
                value={pasteBlockJson}
                onChange={e => { setPasteBlockJson(e.target.value); setPasteBlockError(''); }}
              />
              {pasteBlockError && <div className="text-danger mt-1" style={{ fontSize: '0.7rem' }}>{pasteBlockError}</div>}
              <button
                className="btn btn-sm btn-outline-primary mt-1"
                style={{ fontSize: '0.72rem' }}
                onClick={handlePasteBlock}
                disabled={!pasteBlockJson.trim()}
              >
                Lisää lohko osioon
              </button>
            </div>
          </>
        )}
      </div>}




    </div>
    </>
  );
}